<template lang="">
    <v-card>
        <s-crud
            ref="crud"
            :config="config"
            title="Utilidades"
            :filter="filter"
            search-input
            @rowSelected="rowSelected($event)"
        >
            <template v-slot:filter>
                <v-container>
                    <v-row style="margin-bottom: 5px;">
                        <v-col>
                            <s-select
                                label="Año"
                                :items="years"
                                outlined
                                hide-details
                                dense
                                v-model="filter.SurPeriod"
                            ></s-select>
                        </v-col>
                        <v-col>
                            <s-date
                                v-model="filter.DateBegin"
                                label="Fecha de Pago"
                                clearable
                                outlined
                                dense
                            ></s-date>
                        </v-col>
                        <v-col>
                            <s-select-definition
                                :def="1672"
                                v-model="filter.SecRegistrationStatus"
                                label="Estado"
                            ></s-select-definition>
                        </v-col>
                        </v-col>
                    </v-row>
                </v-container>
            </template>
            <template v-slot:options>
                <v-tooltip bottom="">
					<template v-slot:activator="{ on }">
						<v-btn
						v-on="on"
						text
						black 
						small
						@click="openValidationModal()"
						>
						    <v-icon small>mdi-image-check</v-icon>
						</v-btn>
					</template>
					<span>Validar Fotos</span>
				</v-tooltip>

                <v-tooltip bottom="">
					<template v-slot:activator="{ on }">
						<v-btn
						v-on="on"
						text
						black 
						small
						@click="downloadExcelReport()"
						>
						    <v-icon small>mdi-file-export-outline</v-icon>
						</v-btn>
					</template>
					<span>Exportar Excel Bancos</span>
				</v-tooltip>

                <v-tooltip bottom="">
					<template v-slot:activator="{ on }">
						<v-btn
						v-on="on"
						text
						black 
						small
						@click="showTemplateModal = true"
						>
						    <v-icon small>mdi-file-download-outline</v-icon>
						</v-btn>
					</template>
					<span>Descargar Plantilla</span>
				</v-tooltip>

                <v-tooltip bottom="">
					<template v-slot:activator="{ on }">
						<v-btn
						v-on="on"
						text
						black 
						small
						@click="importExcel()"
						>
						    <v-icon small>mdi-file-import-outline</v-icon>
						</v-btn>
					</template>
					<span>Importar Excel</span>
				</v-tooltip>

                <v-tooltip bottom="">
					<template v-slot:activator="{ on }">
						<v-btn
						v-on="on"
						text
						black 
						small
						@click="exportTxt()"
						>
						    <v-icon small>mdi-file-export-outline</v-icon>
						</v-btn>
					</template>
					<span>Exportar TXT</span>
				</v-tooltip>

                <v-tooltip bottom="">
					<template v-slot:activator="{ on }">
						<v-btn
						v-on="on"
						text
						black 
						small
						@click="dialogImportPayments = true"
						>
						    <v-icon small>mdi-cash-check</v-icon>
						</v-btn>
					</template>
					<span>Importar Pagos Procesados</span>
				</v-tooltip>
            </template>
            <template v-slot:item.SecRegistrationStatus="{ item }">
                <v-chip
                    :color="getStatusColor(item.SecRegistrationStatus)"
                    :text-color="getStatusTextColor(item.SecRegistrationStatus)"
                    small
                    class="font-weight-bold"
                >
                    {{ item.SecRegistrationStatusName }}
                </v-chip>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-btn 
                    v-if="item.SecRegistrationStatus === 5"
                    small 
                    icon 
                    color="success" 
                    @click="markAsDeposited(item)"
                    title="Marcar como Depositado"
                >
                    <v-icon small>mdi-check-decagram</v-icon>
                </v-btn>
            </template>
        </s-crud>

        <v-dialog v-model="showValidationModal" max-width="700px" transition="dialog-bottom-transition">
            <v-card rounded="xl" elevation="10" class="pa-2">
                <v-card-title class="text-h6 font-weight-bold pb-2">
                    <v-icon left color="primary" class="mr-2">mdi-shield-check</v-icon>
                    Validación de Identidad
                    <v-spacer></v-spacer>
                    <v-btn icon @click="showValidationModal = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                
                <v-card-text class="pt-4">
                    <v-row v-if="selectedItem" justify="center" align="center">
                        <v-col cols="12" sm="6" class="d-flex flex-column align-center">
                            <div class="text-subtitle-2 text-uppercase text--secondary font-weight-bold mb-3" style="letter-spacing: 1px;">
                                Foto DNI / Rostro
                            </div>
                            <v-card 
                                outlined 
                                rounded="lg" 
                                class="d-flex align-center justify-center grey lighten-5"
                                height="280" 
                                width="100%"
                                style="border: 2px dashed #e0e0e0;"
                            >
                                <v-img
                                    v-if="selectedItem.SurDNIPhoto"
                                    :src="getPhotoUrl(selectedItem.SurDNIPhoto)"
                                    max-height="260"
                                    max-width="260"
                                    class="rounded"
                                    contain
                                ></v-img>
                                <div v-else class="text-center text-body-2 text--disabled">
                                    <v-icon large color="grey lighten-1" class="mb-2">mdi-image-off-outline</v-icon><br>
                                    Sin Registro
                                </div>
                            </v-card>
                        </v-col>
                        
                        <v-col cols="12" sm="6" class="d-flex flex-column align-center">
                            <div class="text-subtitle-2 text-uppercase text--secondary font-weight-bold mb-3" style="letter-spacing: 1px;">
                                Foto Fotocheck
                            </div>
                            <v-card 
                                outlined 
                                rounded="lg" 
                                class="d-flex align-center justify-center grey lighten-5"
                                height="280" 
                                width="100%"
                                style="border: 2px dashed #e0e0e0;"
                            >
                                <v-img
                                    v-if="selectedItem.WorkerPhoto"
                                    :src="getPhotoUrl(selectedItem.WorkerPhoto)"
                                    max-height="260"
                                    max-width="260"
                                    class="rounded"
                                    contain
                                ></v-img>
                                <div v-else class="text-center text-body-2 text--disabled">
                                    <v-icon large color="grey lighten-1" class="mb-2">mdi-account-off-outline</v-icon><br>
                                    Sin Registro
                                </div>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions class="px-6 pb-4 pt-0">
                    <v-spacer></v-spacer>
                    <v-btn 
                        color="grey darken-1" 
                        text 
                        rounded 
                        class="px-4 mr-2"
                        @click="showValidationModal = false"
                    >
                        Cancelar
                    </v-btn>
                    <v-btn 
                        color="primary" 
                        unelevated 
                        rounded 
                        class="px-6 font-weight-bold"
                        @click="validatePhoto(false)"
                        v-if="selectedItem && selectedItem.SecRegistrationStatus === 1"
                    >
                        Validar Identidad
                    </v-btn>
                    <v-btn 
                        color="info" 
                        unelevated 
                        rounded 
                        class="px-6 font-weight-bold"
                        @click="validatePhoto(true)"
                        v-else-if="selectedItem && (selectedItem.SecRegistrationStatus !== 1 || selectedItem.SecRegistrationStatus !== 4)"
                    >
                        <v-icon left>mdi-email-fast</v-icon>
                        Reenviar Correo
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Diálogo para Plantilla -->
        <v-dialog v-model="showTemplateModal" max-width="600px">
            <v-card rounded="xl" class="pa-4">
                <v-card-title class="text-h6 font-weight-bold">
                    <v-icon left color="primary" class="mr-2">mdi-file-download-outline</v-icon>
                    Descargar Plantillas de Importación
                </v-card-title>
                
                <v-card-text class="pt-2">
                    <v-list two-line subheader>
                        <v-subheader>Opciones Disponibles</v-subheader>
                        
                        <v-list-item>
                            <v-list-item-avatar>
                                <v-icon class="success white--text">mdi-account-details</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title class="font-weight-bold">Plantilla de Cuentas Bancarias</v-list-item-title>
                                <v-list-item-subtitle>Para actualizar DNI, Número de Cuenta y CCI.</v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-action>
                                <v-btn color="success" icon @click="downloadExcelTemplate()">
                                    <v-icon>mdi-download</v-icon>
                                </v-btn>
                            </v-list-item-action>
                        </v-list-item>

                        <v-divider inset></v-divider>

                        <v-list-item>
                            <v-list-item-avatar>
                                <v-icon class="info white--text">mdi-cash-register</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title class="font-weight-bold">Plantilla de Confirmación de Pagos</v-list-item-title>
                                <v-list-item-subtitle>Para confirmar depósitos masivos usando DNI y Monto.</v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-action>
                                <v-btn color="info" icon @click="downloadExcelTemplatePayments()">
                                    <v-icon>mdi-download</v-icon>
                                </v-btn>
                            </v-list-item-action>
                        </v-list-item>
                    </v-list>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text rounded @click="showTemplateModal = false">Cerrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Diálogo para Importación -->
        <v-dialog v-model="dialogImportExcel" max-width="600px">
            <v-card rounded="xl" class="pa-2">
                <v-card-title class="text-h6 font-weight-bold">
                    <v-icon left color="primary" class="mr-2">mdi-file-import-outline</v-icon>
                    Importar Excel de Cuentas
                </v-card-title>
                <v-card-text>
                    <s-import-excel
                        v-if="dialogImportExcel"
                        :headers="headersExcel"
                        @loaded="saveMassive($event)"
                    ></s-import-excel>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text rounded @click="dialogImportExcel = false">Cancelar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Diálogo para Importación de Pagos -->
        <v-dialog v-model="dialogImportPayments" max-width="600px">
            <v-card rounded="xl" class="pa-2">
                <v-card-title class="text-h6 font-weight-bold">
                    <v-icon left color="success" class="mr-2">mdi-cash-check</v-icon>
                    Confirmación de Pagos Bancarios
                </v-card-title>
                <v-card-text>
                    <s-import-excel
                        v-if="dialogImportPayments"
                        :headers="headersExcelPayments"
                        @loaded="saveMassivePayments($event)"
                    ></s-import-excel>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text rounded @click="dialogImportPayments = false">Cancelar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
import _sUtilitiesService from '@/services/HumanResource/Utilities/HmnUtilitiesService';
import _sGenEmail from "@/services/General/GenEmailService.js";
import _sGenParamService from "@/services/General/ParameterService";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { DateTime } from 'luxon';

export default {
    components: {
    },
    data() {
        return {
            filter: {
                SurPeriod: null,
                DateBegin: null,
                SecRegistrationStatus: null
            },
            years: [],
            showValidationModal: false,
            dialogImportExcel: false,
            showTemplateModal: false,
            headersExcel: [
                { column: "DOCUMENTO", value: "PrsDocumentNumber", text: "DNI/DOCUMENTO" },
                { column: "CUENTA", value: "BnkAccountNumber", text: "NRO CUENTA" },
                { column: "CCI", value: "BnkCCI", text: "CCI" },
            ],
            selectedItem: null,
            UrlBase: "",
            dialogImportPayments: false,
            headersExcelPayments: [
                { column: "Documento", value: "PrsDocumentNumber", text: "DNI" },
                { column: "Monto abonado", value: "AmountPaid", text: "MONTO" },
                { column: "Cuenta - Número", value: "BnkAccountNumber", text: "CUENTA" },
            ],
            config: {
                model: {
                    SurID: "ID",
                    SecCreate: "datetime",
                    NtpBirthDate: "date"
                },
                service: _sUtilitiesService,
                headers: [
                    { text: "ID", value: "SurID" },
                    { text: "Nombres y Apellidos", value: "NtpFullName" },
                    { text: "Tipo Documento", value: "TypePersonDocumentName" },
                    { text: "Documento", value: "PrsDocumentNumber" },
                    { text: "Correo Electronico", value: "PemEmail" },
                    { text: "Teléfono", value: "PpnNumberPhone" },
                    { text: "Fecha de Nacimiento", value: "NtpBirthDate" },
                    { text: "Entidad Bancaria", value: "BnkName" },
                    { text: "Numero de cuenta", value: "BnkAccountNumber" },
                    { text: "Estado", value: "SecRegistrationStatus" },
                    { text: "Acciones", value: "actions", sortable: false, align: 'center' },
                ]
            },
        }
    },
    created() {
        this.years = this.$fun.getTop5LastYears();
        const now = DateTime.local();
        this.filter.SurPeriod = now.year - 1;

        // Cálculo de Fecha de Pago (Ciclo Miércoles a Martes)
        // Si es Miércoles (3), la fecha es el siguiente Jueves (+1)
        // Si es de Jueves (4) a Martes (2), la fecha es el Jueves de ese ciclo
        let paymentDate;
        if (now.weekday === 3) {
            paymentDate = now.plus({ days: 1 });
        } else {
            const diff = now.weekday >= 4 ? now.weekday - 4 : now.weekday + 3;
            paymentDate = now.minus({ days: diff });
        }
        this.filter.DateBegin = paymentDate.toISODate();
    },
    methods: {
        rowSelected(rows)
        {
            if(rows.length > 0)
            {
                this.selectedItem = rows[0];
            }
        },
        getStatusColor(status) {
            const map = {
                1: 'blue-grey lighten-4',
                2: 'orange lighten-4',
                3: 'green lighten-4',
                4: 'teal lighten-4',
                5: 'cyan lighten-4',
                6: 'indigo lighten-4'
            };
            return map[status] || 'grey lighten-4';
        },
        getStatusTextColor(status) {
            const map = {
                1: 'blue-grey darken-3',
                2: 'orange darken-4',
                3: 'green darken-4',
                4: 'teal darken-4',
                5: 'cyan darken-4',
                6: 'indigo darken-4'
            };
            return map[status] || 'grey darken-3';
        },
        openValidationModal() {
            this.showValidationModal = true;
        },
        async downloadExcelReport() {
            try {
                // 1. Obtener todos los registros en estado ACEPTADO (3)
                const filterExport = { ...this.filter, SecRegistrationStatus: 3 };
                const params = {
                    filter: filterExport,
                    draw: 1,
                    start: 0,
                    length: -1,
                    order: [{ dir: "asc", column: "SurID" }],
                    searchText: "",
                };

                const resp = await _sUtilitiesService.pagination(params, this.$fun.getUserID());
                if (!resp.data || !resp.data.data || resp.data.data.length === 0) {
                    this.$fun.alert('No se encontraron datos para exportar', 'warning');
                    return;
                }

                const allData = resp.data.data;
                const banks = ['BCP', 'BBVA', 'INTERBANK'];
                
                // 2. Crear Workbook y Hojas
                const workbook = new ExcelJS.Workbook();
                
                for (const bankName of banks) {
                    const sheet = workbook.addWorksheet(bankName);
                    const bankData = allData.filter(item => 
                        (item.BnkName || '').toUpperCase().includes(bankName)
                    );

                    // Definir Columnas por Banco
                    if (bankName === 'BCP') {
                        sheet.columns = [
                            { header: 'N°REGISTRO', key: 'SurID', width: 12 },
                            { header: 'Tipo de Documento', key: 'TypePersonDocumentName', width: 18 },
                            { header: 'Num. Documento (*)', key: 'PrsDocumentNumber', width: 18 },
                            { header: 'Apellido Paterno (*)', key: 'NtpPaternalSurname', width: 25 },
                            { header: 'Apellido Materno (*)', key: 'NtpMaternalSurname', width: 25 },
                            { header: 'Nombres (*)', key: 'NtpName', width: 25 },
                            { header: 'Ocupación (*)', key: 'Occupation', width: 20 },
                            { header: '¿Tiene obligaciones tributarias en algún país diferente a Perú? (*)', key: 'TaxObligations', width: 40 },
                            { header: 'Teléfono (*)', key: 'PpnNumberPhone', width: 15 },
                            { header: 'Correo (*)', key: 'PemEmail', width: 30 },
                            { header: 'Moneda de Cuenta (*)', key: 'Currency', width: 18 },
                            { header: 'Departamento (*)', key: 'Department', width: 18 },
                            { header: 'Provincia (*)', key: 'Province', width: 18 },
                        ];
                    } else if (bankName === 'BBVA') {
                        sheet.columns = [
                            { header: 'Tipo Documento', key: 'TypePersonDocumentName', width: 18 },
                            { header: 'No de documento', key: 'PrsDocumentNumber', width: 18 },
                            { header: 'Apellido Paterno', key: 'NtpPaternalSurname', width: 25 },
                            { header: 'Apellido Materno', key: 'NtpMaternalSurname', width: 25 },
                            { header: 'Nombre Completo', key: 'NtpName', width: 35 },
                            { header: 'Ingreso Neto', key: 'NetIncome', width: 15 },
                            { header: 'Dirección del cliente', key: 'Address', width: 30 },
                            { header: 'Departamento', key: 'Department', width: 18 },
                            { header: 'Provincia', key: 'Province', width: 18 },
                            { header: 'Distrito', key: 'District', width: 18 },
                            { header: 'Celular del Cliente', key: 'PpnNumberPhone', width: 15 },
                            { header: 'E-mail', key: 'PemEmail', width: 30 },
                            { header: 'País de residencia', key: 'CountryResidence', width: 20 },
                            { header: 'País de nacimiento', key: 'CountryBirth', width: 20 },
                            { header: 'País de domicilio', key: 'CountryHome', width: 20 },
                            { header: 'País de otras nacionalidades', key: 'OtherNationalities', width: 25 },
                        ];
                    } else if (bankName === 'INTERBANK') {
                        sheet.columns = [
                            { header: 'TIPO DOC', key: 'TypePersonDocumentName', width: 15 },
                            { header: 'NUMERO DOCUMENTO', key: 'PrsDocumentNumber', width: 18 },
                            { header: 'APELLIDO PATERNO', key: 'NtpPaternalSurname', width: 25 },
                            { header: 'APELLIDO MATERNO', key: 'NtpMaternalSurname', width: 25 },
                            { header: 'PRIMER NOMBRE', key: 'NtpName', width: 20 },
                            { header: 'SEGUNDO NOMBRE', key: 'SecondName', width: 20 },
                            { header: 'SEXO', key: 'Gender', width: 10 },
                            { header: 'ESTADO CIVIL', key: 'CivilStatus', width: 15 },
                            { header: 'FECHA DE NAC. (DD/MM/AAAA)', key: 'NtpBirthDate', width: 25 },
                            { header: 'DIRECCION', key: 'Address', width: 30 },
                            { header: 'DEPARTAMENTO', key: 'Department', width: 18 },
                            { header: 'PROVINCIA', key: 'Province', width: 18 },
                            { header: 'DISTRITO', key: 'District', width: 18 },
                            { header: 'TELEFONO TRABAJO', key: 'WorkPhone', width: 18 },
                            { header: 'NUMERO PASAPORTE', key: 'PassportNumber', width: 20 },
                            { header: 'PAIS DE NACIMIENTO', key: 'CountryBirth', width: 20 },
                            { header: 'PAIS DE NACIONALIDAD', key: 'Nationality', width: 20 },
                            { header: 'TELEFONO CASA (opcional)', key: 'HomePhone', width: 20 },
                            { header: 'Telefono Celular', key: 'PpnNumberPhone', width: 15 },
                            { header: 'EMAIL (opcional)', key: 'PemEmail', width: 30 },
                            { header: 'CÓDIGO PROPIO', key: 'SurID', width: 15 },
                        ];
                    }

                    // Estilo de Encabezado
                    sheet.getRow(1).eachCell((cell) => {
                        cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
                        cell.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: { argb: 'FF1F4E78' } // Navy Blue
                        };
                        cell.alignment = { horizontal: 'center', vertical: 'middle' };
                    });

                    // Agregar Datos
                    bankData.forEach((item, index) => {
                        // Formatear fecha para Interbank si es necesario (DD/MM/AAAA)
                        let birthDate = item.NtpBirthDate;
                        let firstName = (item.NtpName || '').trim();
                        let secondName = '';

                        if (bankName === 'INTERBANK') {
                            // Separar nombres por el primer espacio
                            const firstSpaceIndex = firstName.indexOf(' ');
                            if (firstSpaceIndex !== -1) {
                                secondName = firstName.substring(firstSpaceIndex + 1).trim();
                                firstName = firstName.substring(0, firstSpaceIndex).trim();
                            }

                            if (birthDate) {
                                const d = new Date(birthDate);
                                birthDate = `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`;
                            }
                        }

                        sheet.addRow({
                            ...item,
                            SurID: index + 1,
                            NtpName: firstName,
                            SecondName: secondName,
                            NtpBirthDate: birthDate,
                            // Los campos que no existen en el objeto quedarán vacíos por defecto
                        });
                    });
                }

                // 3. Generar y Descargar
                const buffer = await workbook.xlsx.writeBuffer();
                saveAs(new Blob([buffer]), `Reporte_Utilidades_${new Date().getTime()}.xlsx`);

                // 4. Actualizar estados a 4 (DEPOSITADO) masivamente
                this.$fun.alert('Generando Excel y actualizando estados...', 'info');
                
                const batchID = DateTime.now().toFormat("'S'_yyyyMMdd_HHmmss");
                for (const item of allData) {
                    if (item.SecRegistrationStatus !== 4) {
                        await _sUtilitiesService.changeState({
                            SurID: item.SurID,
                            PrsDocumentNumber : item.PrsDocumentNumber,
                            SecRegistrationStatus: 4,
                            SurExcel: batchID,
                            SurTxt: ""
                        }, this.$fun.getUserID());
                    }
                }
                
                this.$fun.alert('Excel generado y estados actualizados a DEPOSITADO', 'success');
                // Forzar refresco de la grilla
                if(this.$refs.crud) this.$refs.crud.refresh(); 

            } catch (error) {
                console.error(error);
                this.$fun.alert('Error al procesar el reporte: ' + error.message, 'error');
            }
        },
        async downloadExcelTemplate() {
            try {
                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet('Plantilla Cuentas');

                worksheet.columns = [
                    { header: 'DOCUMENTO', key: 'PrsDocumentNumber', width: 20 },
                    { header: 'CUENTA', key: 'BnkAccountNumber', width: 30 },
                    { header: 'CCI', key: 'BnkCCI', width: 30 },
                ];

                // Estilo
                worksheet.getRow(1).font = { bold: true, color: { argb: 'FFFFFFFF' } };
                worksheet.getRow(1).fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FF1F4E78' }
                };

                // Fila de ejemplo
                worksheet.addRow({
                    PrsDocumentNumber: '72103034',
                    BnkAccountNumber: '191-XXXXXXXX-X-XX',
                    BnkCCI: '002-XXXXXXXXXXXXXXXX-XX'
                });

                const buffer = await workbook.xlsx.writeBuffer();
                saveAs(new Blob([buffer]), `Plantilla_Cuentas_Utilidades.xlsx`);
                this.$fun.alert('Plantilla de Cuentas generada', 'success');

            } catch (error) {
                console.error(error);
                this.$fun.alert('Error al generar la plantilla: ' + error.message, 'error');
            }
        },
        async downloadExcelTemplatePayments() {
            try {
                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet('Plantilla Pagos');

                worksheet.columns = [
                    { header: 'Documento', key: 'PrsDocumentNumber', width: 20 },
                    { header: 'Monto abonado', key: 'AmountPaid', width: 20 },
                    { header: 'Cuenta - Número', key: 'BnkAccountNumber', width: 30 },
                ];

                // Estilo
                worksheet.getRow(1).font = { bold: true, color: { argb: 'FFFFFFFF' } };
                worksheet.getRow(1).fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FF2D3748' } // Dark greyish blue
                };

                // Fila de ejemplo
                worksheet.addRow({
                    PrsDocumentNumber: '72103034',
                    AmountPaid: '1500.50',
                    BnkAccountNumber: '191-XXXXXXXX-X-XX'
                });

                const buffer = await workbook.xlsx.writeBuffer();
                saveAs(new Blob([buffer]), `Plantilla_Pagos_Utilidades.xlsx`);
                this.$fun.alert('Plantilla de Pagos generada', 'success');

            } catch (error) {
                console.error(error);
                this.$fun.alert('Error al generar la plantilla: ' + error.message, 'error');
            }
        },
        importExcel() {
            this.dialogImportExcel = true;
        },
        async saveMassive(items) {
            try {
                this.$fun.alert('Actualizando registros...', 'info');
                
                const batchID = DateTime.now().toFormat("'S'_yyyyMMdd_HHmmss");
                for (const item of items) {
                    await _sUtilitiesService.changeState({
                        PrsDocumentNumber: String(item.PrsDocumentNumber),
                        BnkAccountNumber: item.BnkAccountNumber,
                        BnkCCI: item.BnkCCI,
                        SecRegistrationStatus: 4,
                        SurExcel: batchID,
                        SurTxt: ""
                    }, this.$fun.getUserID());
                }
                
                this.dialogImportExcel = false;
                this.$fun.alert('Registros actualizados correctamente', 'success');
                if(this.$refs.crud) this.$refs.crud.refresh();

            } catch (error) {
                console.error(error);
                this.$fun.alert('Error al importar datos: ' + error.message, 'error');
            }
        },
        async exportTxt() {
            try {
                this.$fun.alert('Generando reporte para bancos...', 'info');

                // 1. Obtener todos los registros en estado EXPORTADO A EXCEL (4)
                const filterExport = { ...this.filter, SecRegistrationStatus: 4 };
                const params = {
                    filter: filterExport,
                    draw: 1,
                    start: 0,
                    length: -1,
                    order: [{ dir: "asc", column: "SurID" }],
                    searchText: "",
                };

                const resp = await _sUtilitiesService.pagination(params, this.$fun.getUserID());
                if (!resp.data || !resp.data.data || resp.data.data.length === 0) {
                    this.$fun.alert('No se encontraron datos para exportar', 'warning');
                    return;
                }

                const allData = resp.data.data;
                const banks = ['BCP', 'BBVA', 'INTERBANK'];
                
                // 2. Crear Workbook
                const workbook = new ExcelJS.Workbook();
                
                for (const bankName of banks) {
                    const sheet = workbook.addWorksheet(bankName);
                    
                    // Filtrar datos por banco y que tengan número de cuenta
                    const bankData = allData.filter(item => 
                        (item.BnkName || '').toUpperCase().includes(bankName) &&
                        item.BnkAccountNumber && item.BnkAccountNumber.trim() !== ''
                    );

                    // Definir Columnas y Mapeo por Banco
                    if (bankName === 'BCP') {
                        sheet.columns = [
                            { header: 'Tipo de Cuenta de Abono', key: 'AccountType', width: 25 },
                            { header: 'Cuenta de Abono', key: 'BnkAccountNumber', width: 30 },
                            { header: 'Tipo de Documento de Identidad', key: 'DocumentType', width: 30 },
                            { header: 'Número de Documento de Identidad', key: 'PrsDocumentNumber', width: 30 },
                            { header: 'Nombre del Trabajador', key: 'NtpFullName', width: 45 },
                            { header: 'Tipo de Moneda de Abono', key: 'CurrencyType', width: 25 },
                            { header: 'Monto de Abono', key: 'MountNeto', width: 20 },
                            { header: 'Validación IDC del proveedor vs Cuenta', key: 'IDCValidation', width: 35 },
                        ];

                        // Agregar Datos para BCP
                        bankData.forEach(item => {
                            sheet.addRow({
                                AccountType: 'A',
                                BnkAccountNumber: item.BnkAccountNumber,
                                DocumentType: String(item.TypePersonDocument || '').padStart(2, '0'),
                                PrsDocumentNumber: item.PrsDocumentNumber,
                                NtpFullName: item.NtpFullName,
                                CurrencyType: 'S',
                                MountNeto: item.MountNeto || 0.00,
                                IDCValidation: 'S',
                            });
                        });
                    } else if (bankName === 'BBVA') {
                        sheet.columns = [
                            { header: 'DOI Tipo', key: 'DOIType', width: 15 },
                            { header: 'DOI Número', key: 'PrsDocumentNumber', width: 20 },
                            { header: 'Tipo Abono', key: 'DepositType', width: 15 },
                            { header: 'N° Cuentas a Abonar', key: 'BnkAccountNumber', width: 30 },
                            { header: 'Nombre del Beneficiario', key: 'NtpFullName', width: 45 },
                            { header: 'Importe Abonar', key: 'MountNeto', width: 20 },
                            { header: 'Referencia', key: 'Reference', width: 20 },
                            { header: 'Indicador Aviso', key: 'NoticeIndicator', width: 20 },
                            { header: 'Medio de aviso', key: 'NoticeChannel', width: 20 },
                        ];

                        // Agregar Datos para BBVA
                        bankData.forEach(item => {
                            sheet.addRow({
                                DOIType: 'L',
                                PrsDocumentNumber: item.PrsDocumentNumber,
                                DepositType: 'P',
                                BnkAccountNumber: item.BnkAccountNumber,
                                NtpFullName: item.NtpFullName,
                                MountNeto: item.MountNeto || 0.00,
                                Reference: '',
                                NoticeIndicator: '',
                                NoticeChannel: '',
                            });
                        });
                    } else if (bankName === 'INTERBANK') {
                        sheet.columns = [
                            { header: 'Tipo de Documento*', key: 'DocumentType', width: 20 },
                            { header: 'Número de Documento*', key: 'PrsDocumentNumber', width: 20 },
                            { header: 'Nombre del Beneficiario*', key: 'BeneficiaryFullName', width: 45 },
                            { header: 'Correo Electrónico', key: 'PemEmail', width: 30 },
                            { header: 'N° Celular', key: 'PpnNumberPhone', width: 15 },
                            { header: '', key: 'Empty1', width: 10 },
                            { header: '', key: 'Empty2', width: 10 },
                            { header: '', key: 'Empty3', width: 10 },
                            { header: 'Tipo de Abono*', key: 'DepositType', width: 15 },
                            { header: 'Tipo de Cuenta*', key: 'AccountType', width: 15 },
                            { header: 'Moneda de Cuenta', key: 'AccountCurrency', width: 15 },
                            { header: 'N° Cuenta*', key: 'BnkAccountNumber', width: 30 },
                            { header: 'Moneda de Abono*', key: 'DepositCurrency', width: 15 },
                            { header: 'Monto de Abono*', key: 'MountNeto', width: 20 },
                        ];

                        // Agregar Datos para INTERBANK
                        bankData.forEach(item => {
                            const paternal = (item.NtpPaternalSurname || '').trim();
                            const maternal = (item.NtpMaternalSurname || '').trim();
                            const names = (item.NtpName || '').trim();
                            // Formato: APELLIDO PATERNO; APELLIDO MATERNO; NOMBRES
                            const beneficiaryName = `${paternal}; ${maternal}; ${names}`.toUpperCase();

                            sheet.addRow({
                                DocumentType: String(item.TypePersonDocument || '').padStart(2, '0'),
                                PrsDocumentNumber: item.PrsDocumentNumber,
                                BeneficiaryFullName: beneficiaryName,
                                PemEmail: item.PemEmail || '',
                                PpnNumberPhone: item.PpnNumberPhone || '',
                                Empty1: '',
                                Empty2: '',
                                Empty3: '',
                                DepositType: '09',
                                AccountType: '002',
                                AccountCurrency: '01',
                                BnkAccountNumber: item.BnkAccountNumber,
                                DepositCurrency: '01',
                                MountNeto: item.MountNeto || 0.00,
                            });
                        });
                    } else {
                        // Formato por defecto para otros bancos hasta que se definan
                        sheet.columns = [
                            { header: 'DNI / DOCUMENTO', key: 'PrsDocumentNumber', width: 20 },
                            { header: 'NOMBRE COMPLETO', key: 'NtpFullName', width: 40 },
                            { header: 'NOMBRES', key: 'NtpName', width: 25 },
                            { header: 'APELLIDO PATERNO', key: 'NtpPaternalSurname', width: 25 },
                            { header: 'APELLIDO MATERNO', key: 'NtpMaternalSurname', width: 25 },
                            { header: 'NUMERO DE CUENTA', key: 'BnkAccountNumber', width: 30 },
                            { header: 'MONTO NETO', key: 'MountNeto', width: 15 },
                        ];

                        bankData.forEach(item => {
                            sheet.addRow({
                                PrsDocumentNumber: item.PrsDocumentNumber,
                                NtpFullName: item.NtpFullName,
                                NtpName: item.NtpName,
                                NtpPaternalSurname: item.NtpPaternalSurname,
                                NtpMaternalSurname: item.NtpMaternalSurname,
                                BnkAccountNumber: item.BnkAccountNumber,
                                MountNeto: item.MountNeto,
                            });
                        });
                    }

                    // Estilo de Encabezado (Azul Oscuro, Texto Blanco Negrita)
                    sheet.getRow(1).eachCell((cell) => {
                        cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
                        cell.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: { argb: 'FF1F4E78' }
                        };
                        cell.alignment = { horizontal: 'center', vertical: 'middle' };
                    });
                }

                // 3. Generar y Descargar
                const buffer = await workbook.xlsx.writeBuffer();
                saveAs(new Blob([buffer]), `Reporte_Bancos_Utilidades_${new Date().getTime()}.xlsx`);

                // 4. Actualizar estados a 5 (EXPORTADO PAGO) solo para los que tienen cuenta
                const batchID = DateTime.now().toFormat("'S'_yyyyMMdd_HHmmss");
                for (const item of allData) {
                    const hasAccount = item.BnkAccountNumber && item.BnkAccountNumber.trim() !== '';
                    if (item.SecRegistrationStatus !== 5 && hasAccount) {
                        await _sUtilitiesService.changeState({
                            SurID: item.SurID,
                            PrsDocumentNumber: String(item.PrsDocumentNumber),
                            SecRegistrationStatus: 5,
                            SurExcel: "",
                            SurTxt: batchID
                        }, this.$fun.getUserID());
                    }
                }
                
                this.$fun.alert('Reporte generado y estados actualizados a EXPORTADO PARA PAGO', 'success');
                // Refrescar grilla
                if(this.$refs.crud) this.$refs.crud.refresh(); 

            } catch (error) {
                console.error(error);
                this.$fun.alert('Error al exportar: ' + error.message, 'error');
            }
        },
        getPhotoUrl(base64String) {
            if (base64String && base64String.startsWith('data:image')) {
                return base64String;
            }
            return 'data:image/jpg;base64,' + base64String;
        },
        validatePhoto(isResend = false) {
            if (!this.selectedItem) return;

            let data = {
                SurID: this.selectedItem.SurID,
                SecRegistrationStatus: 3, // ACEPTADO
                SurExcel: "",
                SurTxt: ""
            };

            _sGenParamService.search(
                { PrmName: "UrlBaseUtilities" },
                this.$fun.getUserID(),
            )
            .then(resp => {
                if(resp.data != null) {
                    this.UrlBase = resp.data.PrmValue;
                }
                
                _sUtilitiesService.changeState(data, this.$fun.getUserID()).then(res => {
                    if (res.status === 200 && res.data && res.data.success) {
                        const generatedToken = res.data.SurToken;
                        
                        if (isResend) {
                            this.$fun.alert('Nuevo enlace generado y correo reenviado', 'success');
                        } else {
                            this.$fun.alert('Solicitud verificada y estado actualizado a ACEPTADO', 'success');
                        }
                        
                        this.selectedItem.SecRegistrationStatus = 3; // Actualizar localmente el grid
                        this.showValidationModal = false;

                        // Enviar correo de confirmación
                        const userEmail = "desarrollador.ti@sunshineperu.com" //this.selectedItem.PemEmail;
                        if (userEmail) {
                            const link = `${this.UrlBase}/aceptacion?token=${generatedToken}`;
                            
                            const emailBody = `
                                <div style="font-family: Arial, sans-serif; background-color: #f4f6f9; padding: 40px 20px;">
                                    <div style="max-width: 600px; margin: 0 auto; background-color: #ffffff; border-radius: 8px; overflow: hidden; box-shadow: 0 4px 6px rgba(0,0,0,0.1);">
                                        <div style="background-color: #1a56db; color: #ffffff; text-align: center; padding: 30px 20px;">
                                            <h2 style="margin: 0; font-size: 24px;">Verificación de Solicitud Exitosa</h2>
                                        </div>
                                        <div style="padding: 40px 30px; text-align: center; color: #4a5568;">
                                            <p style="font-size: 16px; margin-bottom: 20px;">Estimado/a <strong>${this.selectedItem.NtpFullName}</strong>,</p>
                                            <p style="font-size: 15px; margin-bottom: 20px; line-height: 1.6;">
                                                Nos complace informarle que la información proporcionada en su solicitud para el pago de utilidades ha sido verificada satisfactoriamente.
                                            </p>
                                            <p style="font-size: 15px; margin-bottom: 30px; line-height: 1.6;">
                                                Su proceso en nuestra plataforma continuará de forma regular.
                                            </p>
                                            <div style="background-color: #f8fafc; border: 1px solid #e2e8f0; border-radius: 6px; padding: 20px; margin-bottom: 30px;">
                                                <p style="margin: 0; font-size: 14px; color: #718096;">
                                                    Para seguir con su proceso y validar los últimos datos en la plataforma, por favor ingrese a través del siguiente botón.
                                                </p>
                                            </div>
                                            <a href="${link}" style="display: inline-block; background-color: #2563eb; color: #ffffff; text-decoration: none; padding: 14px 40px; border-radius: 50px; font-weight: bold; font-size: 16px; transition: background-color 0.3s;">
                                                Continuar Proceso
                                            </a>
                                        </div>
                                        <div style="background-color: #f1f5f9; padding: 20px; text-align: center; color: #94a3b8; font-size: 12px;">
                                            <p style="margin: 0;">Este es un mensaje generado automáticamente por el Sistema de Utilidades SunExpert. Por favor, no responda a este correo.</p>
                                        </div>
                                    </div>
                                </div>
                            `;
                            
                            const mailPayload = {
                                emailTo: userEmail, 
                                subject: "Solicitud Verificada - Sistema de Utilidades",
                                bodyMail: emailBody,
                            };
                            
                            _sGenEmail.sendEmail(mailPayload, this.$fun.getUserID())
                                .then(resMail => {
                                    console.log("Correo enviado exitosamente a: " + userEmail);
                                })
                                .catch(errMail => {
                                    console.error("Error enviando correo electrónico a " + userEmail, errMail);
                                });
                        }
                    }
                }).catch(err => {
                    this.$fun.alert('Error al validar y guardar: ' + err, 'error');
                });
            }).catch(errParam => {
                this.$fun.alert('Error obteniendo parámetro URL: ' + errParam, 'error');
            });
        },
        async markAsDeposited(item) {
            this.$fun.alertFull('¿Está seguro de marcar este registro como DEPOSITADO?', 'question').then(async (resp) => {
                if (resp.value) {
                    try {
                        this.$fun.alert('Actualizando estado...', 'info');
                        
                        const res = await _sUtilitiesService.changeState({
                            SurID: item.SurID,
                            PrsDocumentNumber: String(item.PrsDocumentNumber),
                            BnkAccountNumber: item.BnkAccountNumber,
                            BnkCCI: item.BnkCCI,
                            SecRegistrationStatus: 6, // DEPOSITADO
                            SurExcel: "",
                            SurTxt: ""
                        }, this.$fun.getUserID());

                        if (res.status === 200 && res.data && res.data.success) {
                            this.$fun.alert('Registro marcado como DEPOSITADO correctamente', 'success');
                            
                            if (this.$refs.crud) this.$refs.crud.refresh();
                        } else {
                            throw new Error(res.data?.message || 'Error desconocido al actualizar estado');
                        }
                    } catch (error) {
                        console.error(error);
                        this.$fun.alert('Error al marcar como depositado: ' + error.message, 'error');
                    }
                }
            });
        },
        async saveMassivePayments(items) {
            try {
                this.$fun.alert('Confirmando pagos y notificando...', 'info');
                const batchID = DateTime.now().toFormat("'S'_yyyyMMdd_HHmmss");
                const depositDate = DateTime.now().toISO();

                // 1. Obtener todos los datos actuales para poder enviar correos (necesitamos PemEmail, NtpFullName, etc)
                // Usamos length: -1 para tener todos los registros actuales
                const params = {
                    filter: { ...this.filter, length: -1 },
                    draw: 1,
                    start: 0,
                    length: -1,
                };
                const respGrid = await _sUtilitiesService.pagination(params, this.$fun.getUserID());
                const allSystemData = respGrid.data?.data || [];

                for (const excelItem of items) {
                    const dni = String(excelItem.PrsDocumentNumber).trim();
                    const systemItem = allSystemData.find(s => String(s.PrsDocumentNumber).trim() === dni);

                    if (systemItem) {
                        // Actualizar estado
                        await _sUtilitiesService.changeState({
                            SurID: systemItem.SurID,
                            PrsDocumentNumber: dni,
                            BnkAccountNumber: excelItem.BnkAccountNumber || systemItem.BnkAccountNumber,
                            SecRegistrationStatus: 6, // DEPOSITADO
                            SurExcel: "",
                            SurTxt: batchID,
                            SurDepositDateSunshine: depositDate
                        }, this.$fun.getUserID());

                        // Enviar correo
                        // await this.sendDepositEmail(systemItem);
                    }
                }
                
                this.dialogImportPayments = false;
                this.$fun.alert('Pagos procesados y trabajadores notificados correctamente', 'success');
                if(this.$refs.crud) this.$refs.crud.refresh();

            } catch (error) {
                console.error(error);
                this.$fun.alert('Error al procesar pagos: ' + error.message, 'error');
            }
        },
        async sendDepositEmail(item) {
            try {
                const firstName = item.NtpFullName;
                const currentPeriod = item.SurPeriod;
                
                const emailBody = `
                <div style="font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; background-color: #f4f6f9; padding: 40px 20px; text-align: center;">
                    <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width: 600px; margin: 0 auto; background-color: #ffffff; border-radius: 20px; overflow: hidden; box-shadow: 0 10px 25px rgba(0,0,0,0.05); text-align: left;">
                        <tr>
                            <td style="background-color: #1a1a1a; padding: 30px 20px; text-align: center;">
                                <img src="https://sunshineperu.com/img/AppLogo.png" alt="SUNSHINE" style="max-height: 45px; display: block; margin: 0 auto; object-fit: contain;" />
                            </td>
                        </tr>
                        <tr>
                            <td style="padding: 40px 30px;">
                                <div style="text-align: center; margin-bottom: 25px;">
                                    <span style="font-size: 50px;">🎉</span>
                                    <h1 style="color: #10b981; font-size: 24px; font-weight: 800; margin: 10px 0;">¡Utilidades Depositadas!</h1>
                                    <p style="color: #6b7280; font-size: 14px;">✨ El proceso ha culminado exitosamente ✨</p>
                                </div>
                                <p style="color: #4b5563; font-size: 15px; line-height: 1.6; margin-bottom: 20px;">
                                    Hola <b style="color: #111827;">${firstName}</b>,<br>
                                    Nos alegra informarte que se ha realizado el depósito de tus utilidades correspondiente al ejercicio <b>${currentPeriod}</b>.
                                </p>
                                <div style="background-color: #f0fdf4; border-left: 4px solid #10b981; padding: 15px; margin-bottom: 25px;">
                                    <p style="color: #065f46; font-size: 14px; margin: 0;">
                                        El abono se realizó en su cuenta del banco <b>${item.BnkName || 'asignado'}</b>.
                                    </p>
                                </div>
                                <p style="color: #6b7280; font-size: 13px; margin-bottom: 0;">
                                    Gracias por ser parte de la familia Sunshine. ¡Disfruta de este beneficio! 🌟
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td style="background-color: #f9fafb; padding: 20px; border-top: 1px solid #f3f4f6; text-align: center;">
                                <p style="color: #9ca3af; font-size: 11px; margin: 0; text-transform: uppercase; letter-spacing: 1px; font-weight: 600;">
                                    &copy; 2026 Sistema de Gestión de Utilidades Sunshine
                                </p>
                            </td>
                        </tr>
                    </table>
                </div>`;

                const emailData = {
                    emailTo: item.PemEmail,
                    subject: "🎉 ¡Tus utilidades ya están depositadas! - Sunshine",
                    bodyMail: emailBody,
                };

                await _sGenEmail.sendEmail(emailData, this.$fun.getUserID());

            } catch (error) {
                console.error("Error enviando correo de depósito:", error);
                // No lanzamos error para no detener el proceso masivo si un correo falla
            }
        }
    },
}

</script>